module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/card-details/card-details-modal.component.css
// module id = ./src/app/achelos-iot/modals/card-details/card-details-modal.component.css
// module chunks = main